import React, { useEffect, useState } from "react";
import NavbarHeader from "../../../Navbarheader/NavbarHeader";
import Footer from "../../../Footer/Footer";


import NextProjectButton from "../components/NextProjectButton";
import B01 from "./components/B01";
import B02 from "./components/B02";
import B03 from "./components/B03";
import B04 from "./components/B04";
import B05 from "./components/B05";
import B06 from "./components/B06";
import B07 from "./components/B07";
import B08 from "./components/B08";
import B09 from "./components/B09";
import B10 from "./components/B10";
import B11 from "./components/B11";
import B12 from "./components/B12";
import B13 from "./components/B13";
import B14 from "./components/B14";

import { useNavigate } from 'react-router-dom';

function Notarymeet() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
   const navigate = useNavigate();
 

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const handleNextProjectClick = () => {
    navigate('/project/ola');
  };

  

  return (
    <div fluid className="scroll-container">
      <NavbarHeader />
      <div
        style={{
          backgroundColor: "#343434",
          paddingTop: isSmallScreen ? "7rem" : "0px",
        }}
      >
       <B01 />
       <B02 />
       <B03 />
       <B04 />
       <B05 />
       <B06 />
       <B07 />
       <B08 />
       <B09 />
       <B10 />
       <B11 />
       <B12 />
       <B13 />
       
        <div id="showNextButton">
        <B14 />
        </div>
      </div>
      <Footer />

      <NextProjectButton 
        sectionId="showNextButton" 
        onClick={handleNextProjectClick} 
      />

     
    </div>
  );
}

export default Notarymeet;
